<template>
  <div class="stage-frame" ref="frame">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
export default {
  name: 'StageFrame',

  mounted() {
    this.$game.init(this.$refs.frame, this.$refs.canvas);
  },
};
</script>

<style lang="scss" scoped>
.stage-frame {
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 375px;
  height: 812px;

  transform: translateX(-50%);

  canvas {
    transform: scale(var(--rw));
    transform-origin: 50% 100%;
  }
}
</style>
